export const MIN_MINUTES_PAST = -15;
export const MAX_MINUTES_FUTURE = 120;

export const REMINDER_WINDOW_OVERLAP_MS = 5 * 60 * 1000;
export const MAX_MS_BEFORE_REFRESH = MAX_MINUTES_FUTURE * 60 * 1000 - REMINDER_WINDOW_OVERLAP_MS;
export const MIN_MS_BEFORE_REFRESH = REMINDER_WINDOW_OVERLAP_MS;

// Maximum time we can schedule a timer in the future.
// NOTE: We use 24 days here so that we don't go over setTimeout 32-bit signed integer limit.
// If that happens, client will get into an infinite timer loop and consume a bunch of CPU.
export const MAX_MS_FOR_TIMER = 24 * 24 * 60 * 60 * 1000;
